import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-support",
  templateUrl: "./support.component.html",
  styleUrls: ["./support.component.scss"]
})
export class SupportComponent implements OnInit {

  constructor(
    private readonly activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  public close(): void {
    this.activeModal.close();
  }
}
